export const ABWASSERBEHANDLUNG = "ABWASSERBEHANDLUNG";
export const KLEINKLAERANLAGE = "KLEINKLAERANLAGE";
export const ABWASSERVORBEHANDLUNG = "ABWASSERVORBEHANDLUNG";
export const ANLAGE_AUSSERHALB = "ANLAGE_AUSSERHALB";
export const MISCHWASSER = "MISCHWASSER";
export const NIEDERSCHLAGSWASSER = "NIEDERSCHLAGSWASSER";

export function anlagenartIdToObj(id) {
    switch (id) {
        case ABWASSERBEHANDLUNG:
            return { id: ABWASSERBEHANDLUNG, value: "Abwasserbehandlung" };
        case KLEINKLAERANLAGE:
            return { id: KLEINKLAERANLAGE, value: "Kleinkläranlage" };
        case ABWASSERVORBEHANDLUNG:
            return { id: ABWASSERVORBEHANDLUNG, value: "Abwasservorbehandlung" };
        case ANLAGE_AUSSERHALB:
            return { id: ANLAGE_AUSSERHALB, value: "Anlage ist außerhalb" };
        case MISCHWASSER:
            return { id: MISCHWASSER, value: "Mischwasser" };
        case NIEDERSCHLAGSWASSER:
            return { id: NIEDERSCHLAGSWASSER, value: "Niederschlagswasser" };
        default:
            return null;
    }
}
